export default class {
	constructor(idAdesao, idItemAta, quantidade) {
		this.idAdesao = idAdesao
		this.idItemAta = idItemAta
		this.quantidadeSolicitada = quantidade
	}
}
